module.exports = ".spec-show {\r\n    display: block\r\n}\r\n\r\n.spec-hide {\r\n    display: none\r\n}\r\n\r\n.form-group {\r\n    margin-top : 5px !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/user/create-user/create-user.component.css
// module id = ./src/app/section/user/create-user/create-user.component.css
// module chunks = main